import { css } from '@emotion/react';
import { VisuallyHidden, ZapierLogo } from '@zapier/design-system';
import { isolateComponent } from '@zapier/style-encapsulation';
const Styles = {
    root: css `
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    column-gap: 5px;
    cursor: default;
    user-select: none;
  `,
    cell: css `
    flex-grow: 1;
    flex-shrink: 0;
    text-align: center;
    display: flex;
    flex-direction: row;
    align-items: center;
  `,
};
export const Branding = () => {
    return (isolateComponent("div", { css: Styles.root, "data-testid": "branding" },
        isolateComponent(VisuallyHidden, null, "Zapier"),
        isolateComponent("div", { "aria-hidden": true, css: Styles.cell },
            isolateComponent(ZapierLogo, { width: 81, height: 22 }))));
};
//# sourceMappingURL=Branding.js.map
// @zapier/universal-layout@8.3.1 (41acce620)
